"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FocusableView", {
  enumerable: true,
  get: function get() {
    return _FocusableView.default;
  }
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _console = require("@instructure/console");
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _addEventListener = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/addEventListener"));
var _containsActiveElement = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/containsActiveElement"));
var _InputModeListener = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/InputModeListener"));
var _findTabbable = _interopRequireDefault(require("@instructure/ui-a11y/lib/utils/findTabbable"));
var _FocusableView = _interopRequireDefault(require("./FocusableView"));

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
---
category: components/utilities
---
**/
var Focusable = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Focusable, _Component);
  function Focusable() {
    var _getPrototypeOf2;
    var _this;
    (0, _classCallCheck2.default)(this, Focusable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Focusable)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this._listeners = [];
    _this._inputModeListener = null;
    _this.state = {
      focused: false,
      focusable: false
    };
    _this.handleFocus = function (event) {
      _this.setState({
        focused: true
      });
    };
    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });
    };
    return _this;
  }
  (0, _createClass2.default)(Focusable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var focusable = this.focusable,
        focused = this.focused;
      this.addEventListeners(focusable);
      this.setState({
        focusable: focusable,
        focused: focused
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
        render = _this$props.render,
        children = _this$props.children; // Check if the focusable element changed since the last render

      if (prevState.focusable !== this.focusable) {
        // If the element changed on or while focused, update the focusable element along with the
        // listeners and ensure that we are still focused
        if (this.state.focused) {
          this.focusable.focus();
          this.updateFocusable(true);
        } else {
          this.updateFocusable();
        }
      }
      if (prevProps.children !== children || prevProps.render !== render) {
        this.updateFocusable();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "updateFocusable",
    value: function updateFocusable() {
      var focused = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.focused;
      var focusable = this.focusable;
      if (focusable !== this.state.focusable) {
        this.removeEventListeners();
        this.setState({
          focusable: focusable,
          focused: focused
        });
        this.addEventListeners(focusable);
      } else {
        this.setState({
          focused: focused
        });
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners(focusable) {
      if (focusable) {
        this._listeners.push((0, _addEventListener.default)(focusable, 'focus', this.handleFocus, true));
        this._listeners.push((0, _addEventListener.default)(focusable, 'blur', this.handleBlur, true));
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this._listeners.forEach(function (listener) {
        return listener.remove();
      });
      this._listeners = [];
    }
  }, {
    key: "focus",
    value: function focus() {
      var focusable = this.focusable;
      if (focusable) {
        focusable.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        _this$props2$render = _this$props2.render,
        render = _this$props2$render === void 0 ? children : _this$props2$render;
      var _this$state = this.state,
        focusable = _this$state.focusable,
        focused = _this$state.focused;
      var focusVisible = this.focusVisible;
      if (typeof render === 'function') {
        return render({
          focused: focused,
          focusable: focusable,
          focusVisible: focusVisible
        });
      } else {
        return null;
      }
    }
  }, {
    key: "focused",
    get: function get() {
      return (0, _containsActiveElement.default)(this);
    }
  }, {
    key: "focusable",
    get: function get() {
      var tabbable = (0, _findTabbable.default)(this, true) || [];
      var tabbableCount = tabbable && tabbable.length || 0;

      /*#__PURE__*/
      (/*#__PURE__*/
      0, _console.error)(tabbableCount === 1, "[Focusable] Exactly one tabbable child is required (".concat(tabbableCount, " found)."));
      var focusable = tabbable ? tabbable[0] : false;
      if (focusable && typeof focusable.focus === 'function') {
        return focusable;
      } else {
        return false;
      }
    }
  }, {
    key: "focusVisible",
    get: function get() {
      var _this$state2 = this.state,
        focusable = _this$state2.focusable,
        focused = _this$state2.focused; // always show focus for keyboard input mode

      if (focused && _InputModeListener.default.isKeyboardMode()) return true;
      if (!focusable || !focused) return false;
      var tagName = focusable.tagName,
        type = focusable.type,
        readOnly = focusable.readOnly,
        isContentEditable = focusable.isContentEditable;
      if (tagName == 'INPUT' && Focusable.inputTypes[type] && !readOnly) {
        return true;
      }
      if (tagName == 'TEXTAREA' && !readOnly) {
        return true;
      }
      if (isContentEditable) {
        return true;
      }
      return false;
    }
  }]);
  Focusable.displayName = "Focusable";
  return Focusable;
}(_react.Component);
Focusable.propTypes = {
  /**
   * @param {Object} renderProps
   * @param {Boolean} renderProps.focused - Is the element focused (via keyboard only)?
   * @param {HTMLElement} renderProps.focusable - The focusable element
   * @param {Boolean} renderProps.focusVisible - Whether the focus state should be visible or not
   */
  children: _propTypes.default.func,
  /**
   * Identical to children
   */
  render: _propTypes.default.func
};
Focusable.defaultProps = {
  children: null,
  render: void 0
};
Focusable.inputTypes = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
var _default = Focusable;
exports.default = _default;